import React from "react";
import BaseInput from "./BaseInput";

interface NameInputProps {
  name: string;
  setName: (value: string) => void;
  useFloatingLabel?: boolean;
  label?: string;
}

export default function NameInput({
  name,
  setName,
  useFloatingLabel = true,
  label = "Name"
}: NameInputProps) {
  return (
    <BaseInput
      value={name}
      onChange={setName}
      label={label}
      type="text"
      useFloatingLabel={useFloatingLabel}
    />
  );
} 